import React from "react";
import { Link } from "react-router-dom";
import logo_Resaneh from '../images/logo_Resaneh.png';
import logo_ENemad from '../images/logo_ENemad.png';
import ico_instagram from '../images/instagram.svg';
import ico_youtube from '../images/youtube.svg';
import ico_tweeter from '../images/twitter.svg';
import ico_telegram from '../images/telegram.svg';
import ico_whatsapp from '../images/whatsapp.svg';
import '../../main.css';


function Footer() {
    return (
        <>
        <section className="section footer footer-bottom  bg-dark text-white">
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <h6>گواهینامه ها</h6>
                        <div className="certificate-images">
                        <img src={logo_ENemad} alt="گواهینامه نماد" />
                        <img src={logo_Resaneh} alt="گواهینامه رسانه" />
                        </div>
                    </div>

                    <div className="col-md-4">
                            <h6>لینک‌های مهم</h6>
                            <hr />
                            <div><Link to="/">صفحه اصلی</Link></div>
                            <hr />
                            <div className="social-icons">
                            
        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
        <img src={ico_instagram} width="40" height="40" alt="instagram" />
        </a>
        <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
            <img src={ico_youtube} width="40" height="40" alt="youtube" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <img src={ico_tweeter} width="40" height="40" alt="tweeter" />
        </a>
        <a href="https://t.me" target="_blank" rel="noopener noreferrer">
            <img src={ico_telegram} width="40" height="40" alt="Telegram" />
        </a>
        <a href="https://wa.me/989163449967?text=سلام" target="_blank" rel="noopener noreferrer">
        <img src={ico_whatsapp} width="40" height="40" alt="whatsapp" />
       </a>
        
                            </div>
                        </div>



                    <div className="col-md-4">
                        <h6>ارتباط با ما</h6>
                        <hr />
                        <div><p className="text-secondary mb-1">09120676042</p></div>
                        <div><p className="text-secondary mb-1">09163449967</p></div>
                        <div><p className="text-secondary mb-1">09169129967</p></div>
                        <div><p className="text-secondary mb-1">06142249791</p></div>
                        <div><p className="text-secondary mb-1">06142249855</p></div>
                        <div><p className="text-secondary mb-1">Info@RAYNOGroup.Com</p></div>
                    </div>
                </div>
            </div>

        </section>

        <div className="footer-bottom bg-dark text-white text-center p-3">
                <p>© تمامی حقوق مادی و معنوی متعلق به شرکت فنی مهندسی پویارایانه فرتاک می‌باشد</p>
            </div>

        </>
    );
}

export default Footer;
